@import '../../../../../constants/spacing.module.less';

.customs-information-summary-data {
  margin-left: @space-8;
  padding: @space-0 @space-4;
  background: var(--order-details-canvas--info-pill-background--color);
  border: 1px solid var(--order-details-canvas--info-pill-background--color);
  border-radius: 4px;
  color: var(--default--header--text-color--1);
}

.customs-information-section-content {
  padding: 0 @space-16;
  color: var(--default--text-color--17);
}

.section-divider {
  border: none;
  border-top: 1px solid var(--grey-200);
  margin: @space-16 0;
}

.error-badge {
  height: 65%;
  margin-left: @space-8;
  padding: @space-4;
}

.warning-badge {
  margin-left: @space-8;
  padding: @space-4;

  background: var(--warning--message--background-color--1);
  border: 1px solid var(--warning--message--background-color--2);
  border-radius: 4px;
  color: var(--default--header--text-color--1);

  &:empty {
    display: none;
  }
}
